import React from 'react';
import Icon from 'components/atoms/Icon';
import { UserFileMessage as UserFileMessageType } from 'types/chat.types';

interface UserFileMessageProps {
  message: UserFileMessageType;
}

const UserFileMessage: React.FC<UserFileMessageProps> = ({ message }) => {
  const { fileName, fileSize, timestamp, content } = message;
  const fileSizeKB = (fileSize / 1024).toFixed(2);

  return (
    <div className="self-end flex flex-col items-end">
      <div className="bg-[#EFFBF2] border border-[#0E74661A] text-gray-800 px-4 py-3 rounded-2xl rounded-br-md max-w-sm">
        {content && content !== `Uploaded: ${fileName}` && (
          <div className="mb-2 text-sm whitespace-pre-wrap text-gray-800">
            {content}
          </div>
        )}
        <div className="flex items-center gap-2">
          <Icon name="document" className="w-5 h-5 text-gray-700" />
          <div>
            <div className="font-medium text-sm text-gray-800">{fileName}</div>
            <div className="text-xs text-gray-600">{fileSizeKB} KB</div>
          </div>
        </div>
      </div>
      <div className="text-xs text-gray-400 mt-1 mr-2">
        {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>
  );
};

export default UserFileMessage;
